import { Link } from 'react-router-dom'
import { pageTemplates } from '@/content/templates'
import Cased from '@/components/ui/Cased'

/** Whole pages to start from, after the components they are built with. */
export default function TemplatesBand() {
  return (
    <section className="mds-section home-templates" aria-labelledby="templates-title">
      <div className="mds-container mds-stack">
        <span className="mds-eyebrow">Templates</span>
        <h2 id="templates-title" className="mds-display">
          <Cased>Start from a whole page.</Cased>
        </h2>
        <p className="mds-lead">
          An agency home, a service, a form and search results, built from these components and themed for
          your mission. Copy them as React or plain HTML.
        </p>
        <ul className="tpl-grid home-templates__grid">
          {pageTemplates.map((template, index) => (
            <li key={template.id} className="tpl-card">
              <img className="tpl-card__thumb" src={`/mds/design/svg/templates/${template.id}.svg`} alt="" loading="lazy" />
              <span className="home-templates__number" aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="tpl-card__title">
                <Link className="tpl-card__link" to={`/templates/${template.id}`}>
                  {template.name}
                </Link>
              </h3>
              <p className="mds-muted">{template.summary}</p>
            </li>
          ))}
        </ul>
        <p>
          <Link className="mds-link" to="/templates">
            Browse all templates
          </Link>
        </p>
      </div>
    </section>
  )
}
